class Utils {
  constructor() {}

  static isEmojiCharacter(substring) {
    for (var i = 0; i < substring.length; i++) {
      var hs = substring.charCodeAt(i);
      if (0xd800 <= hs && hs <= 0xdbff) {
        if (substring.length > 1) {
          var ls = substring.charCodeAt(i + 1);
          var uc = ((hs - 0xd800) * 0x400) + (ls - 0xdc00) + 0x10000;
          if (0x1d000 <= uc && uc <= 0x1f77f) {
            return true;
          }
        }
      } else if (substring.length > 1) {
        var ls = substring.charCodeAt(i + 1);
        if (ls == 0x20e3) {
          return true;
        }
      } else {
        if (0x2100 <= hs && hs <= 0x27ff) {
          return true;
        } else if (0x2B05 <= hs && hs <= 0x2b07) {
          return true;
        } else if (0x2934 <= hs && hs <= 0x2935) {
          return true;
        } else if (0x3297 <= hs && hs <= 0x3299) {
          return true;
        } else if (hs == 0xa9 || hs == 0xae || hs == 0x303d || hs == 0x3030 ||
          hs == 0x2b55 || hs == 0x2b1c || hs == 0x2b1b ||
          hs == 0x2b50) {
          return true;
        }
      }
    }
  }

  static randomNum(max) {
    // 0-9的随机数
    var arr = [] //容器
    var str = ''
    for (var i = 0; i < max; i++) { //循环六次
      var num = Math.random() * 10 //Math.random();每次生成(0-1)之间的数;
      num = parseInt(num)
      arr.push(num)
    }
    str = arr.join("")
    return parseInt(str)
  }

  static getQueryString(key) {
    //获取地址栏参数
    var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg)
    if (r != null) {
      //   return unescape(r[2])
      return decodeURIComponent(r[2]);
    }
    return null;
  }

  static getLocalValue(key_name) {
    var b = window.localStorage.getItem(key_name);
    var c = JSON.parse(b); // 将 JSON 字符串转成对象
    if (c == null) {
      return true;
    }
    var time = c.time;
    var date = c.date;
    if ((parseInt(time) + parseInt(date)) < new Date().getTime()) {
      // 如果 date + time 小于当前时间的时间戳，说明已经超过3600秒的时效时间
      return true;
    } else {
      // 如果 date + time 大于当前时间戳，说明没过期
      var d = c[key_name]; // 之前保存的变量值
      // 然后要怎么用就怎么用
      return d;
    }
  }

  static setLocalValue(key_name, value, exp) {
    var obj = new Object(); // 或者 var obj = {};
    obj[key_name] = value; // 要保存的变量
    obj.time = exp; // 过期时间
    obj.date = new Date().getTime(); // 保存变量时的那个时间点，这里以时间戳为例
    var objString = JSON.stringify(obj); // 由于 localStorage 只能保存字符串内容，所以这里要先把对象转换成 JSON 字符串
    window.localStorage.setItem(key_name, objString);
  }

  static cutString(str, len) {
    //length属性读出来的汉字长度为1
    if (str.length * 2 <= len) {
      return str;
    }
    var strlen = 0;
    var s = "";
    for (var i = 0; i < str.length; i++) {
      s = s + str.charAt(i);
      if (str.charCodeAt(i) > 128) {
        strlen = strlen + 2;
        if (strlen >= len) {
          return s.substring(0, s.length - 1) + "...";
        }
      } else {
        strlen = strlen + 1;
        if (strlen >= len) {
          return s.substring(0, s.length - 2) + "...";
        }
      }
    }
    return s
  }

  static getStringLength(str) {
    if (!str) return 0
    var reg = /^[\u4e00-\u9fa5]{0,}$/
    var len = 0
    for (var i = 0; i < str.length; i++) {
      if (reg.test(str[i])) {
        len += 1
      } else {
        len += 0.5
      }
    }
    return len
  }

  static getReplaceString(str, len) {

    let length = Utils.getStringLength(str)
    if (length >= len) {
      str = str.substring(0, len - 3) + '...'
    }
    return str
  }

  static trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, "")
  }
}

export default Utils